import { ceilingsDiffer } from './isolated-cap';
import type { MarginModeForCap } from './isolated-cap';

/** Adjust-leverage Cross nudge (Figma): Isolated + at isolated max + no open position + ceilings differ. */
export function shouldShowCrossNudge(params: {
  marginType: MarginModeForCap;
  leverage: number;
  crossMax: number;
  effectiveIsolatedMax: number;
  hasOpenPosition: boolean;
}): boolean {
  const { marginType, leverage, crossMax, effectiveIsolatedMax, hasOpenPosition } = params;
  if (marginType !== 'Isolated') return false;
  if (hasOpenPosition) return false;
  if (!ceilingsDiffer(crossMax, effectiveIsolatedMax)) return false;
  return leverage === effectiveIsolatedMax;
}
